import React, { useState, useEffect } from "react";
import axios from "axios";
import { useQuery, useQueryClient } from "react-query";
import useLocalStorage from "react-use-localstorage";
import { FormattedMessage } from "react-intl";
import { useParams } from "react-router-dom";

import Schedule from "./schedule";
import { PreLoader } from "../components/preloader";

import { ScheduleEndpointResponseObject } from "../types/presentation";

const Home: React.FC<{
  locale: string;
  setLocale: any;
}> = ({ locale, setLocale }) => {
  const { event_slug } = useParams<{
    event_slug: string;
  }>();
  // const intl = useIntl();
  const queryClient = useQueryClient();
  const [fetchData, setFetchData] = useState(false);
  // const slug = new URLSearchParams(document.location.search).get('event') || "invalid";
  const [eventPassword] = useLocalStorage(event_slug, "");

  const { data, isLoading, error } = useQuery(
    "event",
    async () => {
       console.log("API-Called");

       console.log("url inside home page ",`${process.env.REACT_APP_API_ENDPOINT}/api/public/schedule/${event_slug}`)
      const response = await axios.get<ScheduleEndpointResponseObject>(
        `${process.env.REACT_APP_API_ENDPOINT}/api/public/schedule/${event_slug}`,
        {
          params: { password: eventPassword },
        }
      );
       console.log("FetchData eventPassword",eventPassword);
       console.log("FetchData",response.data);
      return response.data;
    },
    {
      enabled: fetchData,
      onSuccess: (resp) => {

        const { event } = resp.data;
          console.log("eventDetails",event);
          localStorage.setItem(`event-user-id`, event.user_id);
          localStorage.setItem(`event-event-id`, event._id);
          resp.data.presentations.forEach((presentation) => {
          queryClient.setQueryData(["presentation", presentation._id], () => ({
            statusCode: 201,
            message: "event.fetch-success",
            data: { event, presentation },
          }));
        });
      },
    }
  );

    console.log("error",error)

  useEffect(() => {
     console.log("setFetchData Called");

    if (!data) {
      setFetchData(true);
    }
  }, [data]); //[setFetchData,data]

  // if (isLoading) return <i>home.tsx: isLoading</i>
  if (isLoading) return <PreLoader />;

  if (error || !data) return <div></div>;
  // <div className="login-landing">
  //   <div className="login-container">
  //     <div className="login">
  //       <h4><FormattedMessage id="error.retry.message" /></h4>
  //     </div>
  //   </div>
  // </div>

  const { data: eventData } = data;
  return (
    <div className="home-container-with-login">
      <Schedule
        locale={locale}
        setLocale={setLocale}
        isSpeaker={false}
        eventData={eventData} 
        setSchedule={"schedule"}
      />
    </div>
  );
};

export default Home;
